import { IonIcon } from '@ionic/react';
import { checkmark } from 'ionicons/icons';
import styles from './SetupStepProgress.module.css';

interface SetupStepProgressProps {
    /** Ordered phase labels shown along the rail. */
    steps: string[];
    /** Index of the phase currently in progress. */
    currentStep: number;
}

/**
 * A compact horizontal progress rail for multi-phase setup flows. Completed
 * phases show a checkmark, the current phase is emphasised, and upcoming phases
 * are muted. Purely presentational so it can be reused by any wizard-style flow.
 */
const SetupStepProgress: React.FC<SetupStepProgressProps> = ({ steps, currentStep }) => {
    return (
        <div className={styles.progress}>
            {steps.map((label, index) => {
                const isDone = index < currentStep;
                const isActive = index <= currentStep;

                return (
                    <div className={styles.step} key={label}>
                        <div className={styles.node}>
                            <span className={`${styles.marker} ${isActive ? styles.markerActive : ''}`}>
                                {isDone ? <IonIcon icon={checkmark} /> : index + 1}
                            </span>
                            <span className={`${styles.label} ${index === currentStep ? styles.labelActive : ''}`}>
                                {label}
                            </span>
                        </div>
                        {index < steps.length - 1 && (
                            <span className={`${styles.connector} ${isDone ? styles.connectorDone : ''}`} />
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default SetupStepProgress;
